export class IntersectionObserverHelper {
    constructor(elementToObserve, options = {}, callback) {
        if (!elementToObserve || !(elementToObserve instanceof Element)) {
            throw new Error('Please provide a valid DOM element to observe.');
        }

        this.elementToObserve = elementToObserve;
        this.options = options;
        this.callback = callback;

        this.intersectionObserver = new IntersectionObserver(this.handleIntersect.bind(this), this.options);
        this.intersectionObserver.observe(this.elementToObserve);
    }

    handleIntersect(entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                if (typeof this.callback === 'function') {
                    this.callback(entry, observer);
                } else {
                    console.log('Intersection occurred!');
                }
            }
        });
    }

    disconnect() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
        }
    }
}